

// import React, { useState, useEffect, useRef } from "react";
// import { useParams } from "react-router-dom";
// import { Spin, Button, Result, Typography, Card, Divider, Tag, Progress, Row, Col, message } from "antd";
// import {
//     SafetyCertificateOutlined,
//     CheckCircleOutlined,
//     CloseCircleOutlined,
//     CalendarOutlined,
//     UserOutlined,
//     BookOutlined,
//     TrophyOutlined,
//     BarChartOutlined,
//     DownloadOutlined,
// } from "@ant-design/icons";
// import { QRCodeCanvas } from "qrcode.react";
// import html2canvas from "html2canvas";
// import axios from "axios";
// import API_BASE from "../../config/apiConfig";

// const { Title, Text } = Typography;

// const BadgeVerification = () => {
//     const { code } = useParams();
//     const badgeRef = useRef(null);
//     const [loading, setLoading] = useState(true);
//     const [badgeData, setBadgeData] = useState(null);
//     const [error, setError] = useState(null);
//     const [downloading, setDownloading] = useState(false);

//     // Template du modérateur
//     const [templateHtml, setTemplateHtml] = useState(null);
//     const [templateSettings, setTemplateSettings] = useState(null);

//     useEffect(() => {
//         const verifyBadge = async () => {
//             try {
//                 setLoading(true);
//                 const response = await axios.get(`${API_BASE}/badges/verify/${code}`);
//                 setBadgeData(response.data);

//                 // Charger le template du modérateur si le badge est valide
//                 if (response.data?.valid && response.data?.courseName) {
//                     try {
//                         // Récupérer le courseId depuis les données du badge
//                         // On utilise l'endpoint last-template avec le courseId
//                         // Le courseId n'est pas dans badgeData, on essaye via l'API
//                         const courseId = response.data.courseId;
//                         if (courseId) {
//                             const templateRes = await axios.get(`${API_BASE}/badges/last-template/${courseId}`);
//                             if (templateRes.data) {
//                                 setTemplateHtml(templateRes.data.templateHtml || null);
//                                 if (templateRes.data.templateSettings) {
//                                     try {
//                                         const parsed = JSON.parse(templateRes.data.templateSettings);
//                                         console.log("📦 Template settings chargés:", {
//                                             useImageBackground: parsed.useImageBackground,
//                                             hasBackgroundPreview: !!parsed.backgroundPreview,
//                                             backgroundPreviewLength: parsed.backgroundPreview?.length || 0,
//                                             backgroundColor: parsed.backgroundColor,
//                                         });
//                                         setTemplateSettings(parsed);
//                                     } catch (e) {
//                                         console.error("Erreur parsing settings:", e);
//                                     }
//                                 }
//                             }
//                         }
//                     } catch (e) {
//                         console.log("Pas de template badge trouvé, utilisation du template par défaut");
//                     }
//                 }
//             } catch (err) {
//                 if (err.response?.status === 404) {
//                     setError("Ce badge n'existe pas ou le code de vérification est invalide.");
//                 } else {
//                     setError("Erreur lors de la vérification du badge.");
//                 }
//             } finally {
//                 setLoading(false);
//             }
//         };

//         if (code) {
//             verifyBadge();
//         }
//     }, [code]);

//     // Remplacer les variables dans le template
//     const processTemplate = (html) => {
//         if (!html || !badgeData) return "";
//         const today = badgeData.generatedAt
//             ? new Date(badgeData.generatedAt).toLocaleDateString("fr-FR")
//             : new Date().toLocaleDateString("fr-FR");
//         const score = badgeData.noteFinale != null ? badgeData.noteFinale.toFixed(2) : "0";

//         return html
//             .replace(/\$\{studentName\}/g, badgeData.studentName || "")
//             .replace(/\{\{studentName\}\}/g, badgeData.studentName || "")
//             .replace(/\{\{username\}\}/g, badgeData.studentName || "")
//             .replace(/\$\{courseTitle\}/g, badgeData.courseName || "")
//             .replace(/\{\{courseTitle\}\}/g, badgeData.courseName || "")
//             .replace(/\{\{courseName\}\}/g, badgeData.courseName || "")
//             .replace(/\$\{score\}/g, score)
//             .replace(/\{\{score\}\}/g, score)
//             .replace(/\$\{threshold\}/g, String(badgeData.threshold || 0))
//             .replace(/\{\{threshold\}\}/g, String(badgeData.threshold || 0))
//             .replace(/\$\{today\}/g, today)
//             .replace(/\{\{date\}\}/g, today);
//     };

//     // Télécharger le badge
//     const handleDownloadBadge = async () => {
//         if (!badgeRef.current) {
//             message.error("Badge non disponible.");
//             return;
//         }

//         try {
//             setDownloading(true);
//             const canvas = await html2canvas(badgeRef.current, {
//                 backgroundColor: null,
//                 scale: 3,
//                 useCORS: true,
//                 allowTaint: true,
//             });

//             const link = document.createElement("a");
//             link.download = `badge_${badgeData.studentName}_${badgeData.courseName || "cours"}.png`;
//             link.href = canvas.toDataURL("image/png");
//             link.click();

//             message.success("🎉 Badge téléchargé !");
//         } catch (error) {
//             console.error("Erreur téléchargement:", error);
//             message.error("Erreur lors du téléchargement.");
//         } finally {
//             setDownloading(false);
//         }
//     };

//     if (loading) {
//         return (
//             <div style={styles.loadingContainer}>
//                 <Spin size="large" />
//                 <Title level={4} style={{ marginTop: 24, color: '#667eea' }}>
//                     Vérification du badge...
//                 </Title>
//             </div>
//         );
//     }

//     if (error || !badgeData?.valid) {
//         return (
//             <div style={styles.pageContainer}>
//                 <Card style={styles.errorCard}>
//                     <Result
//                         icon={<CloseCircleOutlined style={{ color: '#ff4d4f' }} />}
//                         title="Badge non trouvé"
//                         subTitle={error || "Le code de vérification est invalide."}
//                         extra={
//                             <Button type="primary" href="/" style={styles.backBtn}>
//                                 Retour à l'accueil
//                             </Button>
//                         }
//                     />
//                 </Card>
//             </div>
//         );
//     }

//     const noteFinale = badgeData.noteFinale;
//     const threshold = badgeData.threshold;
//     const passed = noteFinale != null && noteFinale >= threshold;
//     const maxNote = 20;
//     const progressPercent = noteFinale != null ? Math.round((noteFinale / maxNote) * 100) : 0;
//     const qrLink = `https://nomidya.com/badge/verify/${code}`;

//     const formattedDate = badgeData.generatedAt
//         ? new Date(badgeData.generatedAt).toLocaleDateString('fr-FR', {
//             day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit'
//         })
//         : "Non disponible";

//     // Settings du template
//     const s = templateSettings || {};
//     const bgColor = s.backgroundColor || "#1890ff";
//     const txtColor = s.textColor || "#ffffff";
//     const bWidth = s.badgeWidth || 300;
//     const bHeight = s.badgeHeight || 420;
//     const logoW = s.logoWidth || 60;
//     const logoH = s.logoHeight || 60;
//     const useImgBg = s.useImageBackground || false;
//     const bgImg = s.backgroundPreview || null;
//     const logoImg = s.logoPreview || null;

//     const processedHtml = processTemplate(templateHtml);

//     // Template par défaut si aucun template modérateur
//     const defaultBadgeHtml = `
//         <div style="text-align: center; height: 100%; padding: 20px; display: flex; flex-direction: column; justify-content: center;">
//             <div>
//                 <h2 style="margin: 10px 0; font-size: 18px; font-weight: bold;">🏆 BADGE DE RÉUSSITE</h2>
//                 <div style="margin: 20px 0;">
//                     <div style="font-size: 14px; margin-bottom: 8px;">Décerné à :</div>
//                     <div style="font-size: 16px; font-weight: bold; text-transform: uppercase; border-bottom: 2px solid currentColor; padding-bottom: 5px; margin: 0 20px;">
//                         ${badgeData.studentName || "Étudiant"}
//                     </div>
//                 </div>
//                 <div style="margin: 20px 0;">
//                     <div style="font-size: 12px; margin-bottom: 5px;">Pour le cours :</div>
//                     <div style="font-size: 13px; font-weight: 600; font-style: italic; padding: 0 10px;">
//                         ${badgeData.courseName || "Cours"}
//                     </div>
//                 </div>
//                 <div style="margin: 20px 0;">
//                     <div style="font-size: 24px; margin-bottom: 5px;">⭐</div>
//                     <div style="font-size: 12px;">Score : ${noteFinale?.toFixed(2) || "0"} / ${threshold}</div>
//                 </div>
//             </div>
//         </div>
//     `;

//     return (
//         <div style={styles.pageContainer}>
//             <Card style={styles.verifyCard}>
//                 <div style={styles.verifyHeader}>
//                     <CheckCircleOutlined style={{ fontSize: 48, color: '#52c41a' }} />
//                     <div>
//                         <Title level={3} style={{ margin: 0, color: '#262626' }}>
//                             Badge vérifié ✅
//                         </Title>
//                         <Text type="secondary">
//                             Ce badge est authentique et a été délivré par Nomidya.
//                         </Text>
//                     </div>
//                 </div>

//                 <Divider />

//                 {/* ✅ Badge visuel généré depuis le template du modérateur */}
//                 <div style={{ display: "flex", justifyContent: "center", marginBottom: 24 }}>
//                     <div
//                         ref={badgeRef}
//                         style={{
//                             width: `${bWidth}px`,
//                             height: `${bHeight}px`,
//                             background: useImgBg && bgImg
//                                 ? `url(${bgImg}) center/cover no-repeat`
//                                 : bgColor,
//                             color: txtColor,
//                             borderRadius: "16px",
//                             position: "relative",
//                             boxShadow: "0 8px 24px rgba(0,0,0,0.15)",
//                             overflow: "hidden",
//                         }}
//                     >
//                         {/* Logo */}
//                         {logoImg && (
//                             <img
//                                 src={logoImg}
//                                 alt="Logo"
//                                 style={{
//                                     position: "absolute", top: "20px", left: "50%",
//                                     transform: "translateX(-50%)",
//                                     width: `${logoW}px`, height: `${logoH}px`,
//                                     borderRadius: "50%", objectFit: "cover",
//                                 }}
//                             />
//                         )}

//                         {/* Contenu HTML */}
//                         <div style={{ padding: "20px", paddingBottom: "80px", height: "100%", position: "relative" }}>
//                             <div dangerouslySetInnerHTML={{
//                                 __html: processedHtml || defaultBadgeHtml
//                             }} />
//                         </div>

//                         {/* QR Code */}
//                         <div style={{
//                             position: "absolute", bottom: "12px", right: "12px",
//                             background: "rgba(255,255,255,0.15)",
//                             borderRadius: "8px", padding: "6px",
//                         }}>
//                             <QRCodeCanvas
//                                 value={qrLink}
//                                 size={52}
//                                 bgColor="transparent"
//                                 fgColor={txtColor}
//                             />
//                         </div>

//                         {/* Date */}
//                         <div style={{
//                             position: "absolute", bottom: "14px", left: "14px",
//                             fontSize: "10px", opacity: 0.8, color: txtColor,
//                         }}>
//                             {badgeData.generatedAt
//                                 ? new Date(badgeData.generatedAt).toLocaleDateString("fr-FR")
//                                 : new Date().toLocaleDateString("fr-FR")}
//                         </div>
//                     </div>
//                 </div>

//                 {/* Informations du badge */}
//                 <div style={styles.infoGrid}>
//                     <div style={styles.infoItem}>
//                         <UserOutlined style={styles.infoIcon} />
//                         <div>
//                             <Text type="secondary" style={{ fontSize: 12 }}>Étudiant</Text>
//                             <div style={{ fontWeight: 600, fontSize: 15, color: '#1890ff', textTransform: 'capitalize' }}>
//                                 {badgeData.studentName}
//                             </div>
//                         </div>
//                     </div>
//                     <div style={styles.infoItem}>
//                         <BookOutlined style={styles.infoIcon} />
//                         <div>
//                             <Text type="secondary" style={{ fontSize: 12 }}>Cours</Text>
//                             <div style={{ fontWeight: 600, fontSize: 15 }}>{badgeData.courseName}</div>
//                         </div>
//                     </div>
//                     <div style={styles.infoItem}>
//                         <CalendarOutlined style={styles.infoIcon} />
//                         <div>
//                             <Text type="secondary" style={{ fontSize: 12 }}>Date d'obtention</Text>
//                             <div style={{ fontWeight: 600, fontSize: 15 }}>{formattedDate}</div>
//                         </div>
//                     </div>
//                     <div style={styles.infoItem}>
//                         <SafetyCertificateOutlined style={styles.infoIcon} />
//                         <div>
//                             <Text type="secondary" style={{ fontSize: 12 }}>Code de vérification</Text>
//                             <div style={{ fontWeight: 600, fontSize: 13, fontFamily: 'monospace', color: '#667eea' }}>
//                                 {badgeData.verificationCode}
//                             </div>
//                         </div>
//                     </div>
//                 </div>

//                 {/* Section Notes détaillées */}
//                 {noteFinale != null && (
//                     <>
//                         <Divider>
//                             <BarChartOutlined style={{ marginRight: 8 }} />
//                             Résultats de l'étudiant
//                         </Divider>

//                         <div style={{ textAlign: 'center', marginBottom: 24 }}>
//                             <Progress
//                                 type="circle"
//                                 percent={progressPercent}
//                                 format={() => (
//                                     <div>
//                                         <div style={{ fontSize: 24, fontWeight: 'bold', color: passed ? '#52c41a' : '#ff4d4f' }}>
//                                             {noteFinale.toFixed(2)}
//                                         </div>
//                                         <div style={{ fontSize: 12, color: '#999' }}>/ {maxNote}</div>
//                                     </div>
//                                 )}
//                                 strokeColor={passed ? '#52c41a' : '#ff4d4f'}
//                                 width={120}
//                             />
//                             <div style={{ marginTop: 8 }}>
//                                 <Tag color={passed ? 'success' : 'error'} style={{ fontSize: 13, padding: '4px 16px' }}>
//                                     {passed ? '✅ Seuil atteint' : '❌ Seuil non atteint'}
//                                 </Tag>
//                                 <div style={{ marginTop: 6 }}>
//                                     <Text type="secondary" style={{ fontSize: 12 }}>
//                                         Seuil requis : <Tag color="blue">{threshold}</Tag>
//                                     </Text>
//                                 </div>
//                             </div>
//                         </div>

//                         <Row gutter={[12, 12]}>
//                             {badgeData.noteControle != null && (
//                                 <Col span={8}>
//                                     <Card size="small" style={styles.noteCard('#f6ffed', '#b7eb8f')}>
//                                         <div style={{ fontSize: 11, color: '#666', marginBottom: 4 }}>📝 Contrôle</div>
//                                         <div style={{ fontSize: 20, fontWeight: 'bold', color: '#52c41a' }}>
//                                             {badgeData.noteControle.toFixed(2)}
//                                         </div>
//                                     </Card>
//                                 </Col>
//                             )}
//                             {badgeData.noteEvaluation != null && (
//                                 <Col span={8}>
//                                     <Card size="small" style={styles.noteCard('#e6f7ff', '#91d5ff')}>
//                                         <div style={{ fontSize: 11, color: '#666', marginBottom: 4 }}>📋 Évaluation</div>
//                                         <div style={{ fontSize: 20, fontWeight: 'bold', color: '#1890ff' }}>
//                                             {badgeData.noteEvaluation.toFixed(2)}
//                                         </div>
//                                     </Card>
//                                 </Col>
//                             )}
//                             {badgeData.noteTraining != null && (
//                                 <Col span={8}>
//                                     <Card size="small" style={styles.noteCard('#fff7e6', '#ffd591')}>
//                                         <div style={{ fontSize: 11, color: '#666', marginBottom: 4 }}>🏋️ Training</div>
//                                         <div style={{ fontSize: 20, fontWeight: 'bold', color: '#fa8c16' }}>
//                                             {badgeData.noteTraining.toFixed(2)}
//                                         </div>
//                                     </Card>
//                                 </Col>
//                             )}
//                         </Row>
//                     </>
//                 )}

//                 {noteFinale == null && (
//                     <div style={{ textAlign: 'center', padding: '16px 0', color: '#999' }}>
//                         <Text type="secondary">
//                             Les notes détaillées ne sont pas encore disponibles.
//                         </Text>
//                     </div>
//                 )}

//                 <Divider />

//                 {/* ✅ Bouton télécharger — génère le badge depuis le template frontend */}
//                 <div style={{ textAlign: 'center' }}>
//                     <Button
//                         type="primary"
//                         size="large"
//                         icon={<DownloadOutlined />}
//                         loading={downloading}
//                         onClick={handleDownloadBadge}
//                         style={styles.downloadBtn}
//                     >
//                         Télécharger mon badge
//                     </Button>
//                 </div>
//             </Card>

//             {/* Footer */}
//             <div style={styles.footer}>
//                 <Text type="secondary" style={{ fontSize: 12 }}>
//                     Badge délivré par <strong>Nomidya E-Learning</strong> •
//                     Vérifiable à tout moment via le QR code ou le lien de vérification
//                 </Text>
//             </div>
//         </div>
//     );
// };

// const styles = {
//     pageContainer: {
//         minHeight: '100vh',
//         background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
//         padding: '40px 20px',
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//     },
//     loadingContainer: {
//         minHeight: '100vh',
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         justifyContent: 'center',
//         background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
//     },
//     verifyCard: {
//         maxWidth: 700,
//         width: '100%',
//         borderRadius: 16,
//         boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
//         border: '2px solid #52c41a',
//     },
//     verifyHeader: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: 20,
//     },
//     errorCard: {
//         maxWidth: 600,
//         width: '100%',
//         borderRadius: 16,
//         boxShadow: '0 8px 30px rgba(0,0,0,0.1)',
//     },
//     infoGrid: {
//         display: 'grid',
//         gridTemplateColumns: 'repeat(2, 1fr)',
//         gap: 16,
//         marginTop: 24,
//     },
//     infoItem: {
//         display: 'flex',
//         alignItems: 'flex-start',
//         gap: 12,
//         padding: '10px 14px',
//         background: '#fafafa',
//         borderRadius: 10,
//     },
//     infoIcon: {
//         fontSize: 20,
//         color: '#667eea',
//         marginTop: 2,
//     },
//     noteCard: (bg, border) => ({
//         textAlign: 'center',
//         borderRadius: 10,
//         background: bg,
//         border: `1px solid ${border}`,
//     }),
//     downloadBtn: {
//         height: 48,
//         paddingLeft: 32,
//         paddingRight: 32,
//         borderRadius: 12,
//         background: 'linear-gradient(135deg, #52c41a 0%, #389e0d 100%)',
//         border: 'none',
//         fontSize: 16,
//         fontWeight: 600,
//         boxShadow: '0 4px 15px rgba(82, 196, 26, 0.4)',
//     },
//     backBtn: {
//         borderRadius: 10,
//         background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
//         border: 'none',
//     },
//     footer: {
//         marginTop: 30,
//         textAlign: 'center',
//         padding: '16px 20px',
//         background: 'rgba(255,255,255,0.7)',
//         borderRadius: 12,
//         maxWidth: 700,
//         width: '100%',
//     },
// };

// export default BadgeVerification;



import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { Spin, Button, Result, Typography, Card, Divider, Tag, Row, Col, message } from "antd";
import {
    SafetyCertificateOutlined, CheckCircleOutlined, CloseCircleOutlined,
    CalendarOutlined, UserOutlined, BookOutlined, TrophyOutlined,
    BarChartOutlined, DownloadOutlined, StarFilled, LockOutlined,
} from "@ant-design/icons";
import { QRCodeCanvas } from "qrcode.react";
import html2canvas from "html2canvas";
import axios from "axios";
import API_BASE from "../../config/apiConfig";

const { Title, Text } = Typography;

const BadgeVerification = () => {
    const { code } = useParams();
    const badgeRef = useRef(null);
    const [badgeData, setBadgeData] = useState(null);
    const [error, setError] = useState(null);
    const [downloading, setDownloading] = useState(false);
    const [templateHtml, setTemplateHtml] = useState(null);
    const [templateSettings, setTemplateSettings] = useState(null);
    const [badgeLoading, setBadgeLoading] = useState(true);

    useEffect(() => {
        if (!code) return;
        const verify = async () => {
            try {
                const res = await axios.get(`${API_BASE}/badges/verify/${code}`);
                setBadgeData(res.data);
                if (res.data?.valid && res.data?.courseId) {
                    axios.get(`${API_BASE}/badges/last-template/${res.data.courseId}`)
                        .then(tRes => {
                            if (tRes.data) {
                                setTemplateHtml(tRes.data.templateHtml || null);
                                if (tRes.data.templateSettings) {
                                    try { setTemplateSettings(JSON.parse(tRes.data.templateSettings)); }
                                    catch (e) { /* ignore */ }
                                }
                            }
                        })
                        .catch(() => {})
                        .finally(() => setBadgeLoading(false));
                } else { setBadgeLoading(false); }
            } catch (err) {
                setError(err.response?.status === 404
                    ? "Ce badge n'existe pas ou le code est invalide."
                    : "Erreur lors de la vérification.");
                setBadgeLoading(false);
            }
        };
        verify();
    }, [code]);

    const processTemplate = (html) => {
        if (!html || !badgeData) return "";
        const today = badgeData.generatedAt ? new Date(badgeData.generatedAt).toLocaleDateString("fr-FR") : new Date().toLocaleDateString("fr-FR");
        const score = badgeData.noteFinale != null ? badgeData.noteFinale.toFixed(2) : "0";
        return html
            .replace(/\$\{studentName\}/g, badgeData.studentName || "")
            .replace(/\{\{studentName\}\}/g, badgeData.studentName || "")
            .replace(/\{\{username\}\}/g, badgeData.studentName || "")
            .replace(/\$\{courseTitle\}/g, badgeData.courseName || "")
            .replace(/\{\{courseTitle\}\}/g, badgeData.courseName || "")
            .replace(/\{\{courseName\}\}/g, badgeData.courseName || "")
            .replace(/\$\{score\}/g, score).replace(/\{\{score\}\}/g, score)
            .replace(/\$\{threshold\}/g, String(badgeData.threshold || 0))
            .replace(/\{\{threshold\}\}/g, String(badgeData.threshold || 0))
            .replace(/\$\{today\}/g, today).replace(/\{\{date\}\}/g, today);
    };

    const handleDownloadBadge = async () => {
        if (!badgeRef.current) { message.error("Badge non disponible."); return; }
        try {
            setDownloading(true);
            const canvas = await html2canvas(badgeRef.current, { backgroundColor: null, scale: 3, useCORS: true, allowTaint: true });
            const link = document.createElement("a");
            link.download = `badge_${badgeData.studentName}_${badgeData.courseName || "cours"}.png`;
            link.href = canvas.toDataURL("image/png");
            link.click();
            message.success("Badge téléchargé !");
        } catch (e) { message.error("Erreur téléchargement."); }
        finally { setDownloading(false); }
    };

    if (error) {
        return (
            <div style={{ padding: 40, display: 'flex', justifyContent: 'center' }}>
                <Card style={{ maxWidth: 500, width: '100%', borderRadius: 16 }}>
                    <Result
                        icon={<CloseCircleOutlined style={{ color: '#ff4d4f' }} />}
                        title="Badge introuvable"
                        subTitle={error}
                        extra={<Button type="primary" href="/" style={{ borderRadius: 8 }}>Retour</Button>}
                    />
                </Card>
            </div>
        );
    }

    if (!badgeData) {
        return (
            <div style={{ padding: 60, textAlign: 'center' }}>
                <Spin size="large" />
                <div style={{ marginTop: 16, color: '#888' }}>Vérification...</div>
            </div>
        );
    }

    if (!badgeData.valid) {
        return (
            <div style={{ padding: 40, display: 'flex', justifyContent: 'center' }}>
                <Card style={{ maxWidth: 500, width: '100%', borderRadius: 16 }}>
                    <Result icon={<CloseCircleOutlined style={{ color: '#ff4d4f' }} />} title="Badge invalide" subTitle="Code non reconnu." />
                </Card>
            </div>
        );
    }

    const noteFinale = badgeData.noteFinale;
    const threshold = badgeData.threshold;
    const passed = noteFinale != null && noteFinale >= threshold;
    const qrLink = `https://nomidya.com/badge/verify/${code}`;
    const formattedDate = badgeData.generatedAt
        ? new Date(badgeData.generatedAt).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric' })
        : "Non disponible";

    const s = templateSettings || {};
    const bgColor = s.backgroundColor || "#1890ff";
    const txtColor = s.textColor || "#ffffff";
    const bWidth = s.badgeWidth || 300;
    const bHeight = s.badgeHeight || 420;
    const useImgBg = s.useImageBackground || false;
    const bgImg = s.backgroundPreview || null;
    const logoImg = s.logoPreview || null;
    const logoW = s.logoWidth || 60;
    const logoH = s.logoHeight || 60;
    const processedHtml = processTemplate(templateHtml);

    const defaultBadgeHtml = `
        <div style="text-align:center;height:100%;padding:20px;display:flex;flex-direction:column;justify-content:center;">
            <div>
                <h2 style="margin:10px 0;font-size:18px;font-weight:bold;">🏆 BADGE DE RÉUSSITE</h2>
                <div style="margin:20px 0;"><div style="font-size:14px;margin-bottom:8px;">Décerné à :</div>
                <div style="font-size:16px;font-weight:bold;text-transform:uppercase;border-bottom:2px solid currentColor;padding-bottom:5px;margin:0 20px;">${badgeData.studentName||""}</div></div>
                <div style="margin:20px 0;"><div style="font-size:12px;margin-bottom:5px;">Pour le cours :</div>
                <div style="font-size:13px;font-weight:600;font-style:italic;">${badgeData.courseName||""}</div></div>
                <div style="margin:20px 0;"><div style="font-size:24px;">⭐</div>
                <div style="font-size:12px;">Score : ${noteFinale?.toFixed(2)||"0"} / ${threshold}</div></div>
            </div>
        </div>`;

    return (
        <div style={{ padding: '24px 16px', maxWidth: 760, margin: '0 auto' }}>

            {/* ═══ STATUS BAR ═══ */}
            <div style={{
                display: 'flex', alignItems: 'center', gap: 12,
                background: '#f6ffed', border: '1px solid #b7eb8f',
                borderRadius: 12, padding: '12px 18px', marginBottom: 16,
            }}>
                <CheckCircleOutlined style={{ fontSize: 28, color: '#52c41a' }} />
                <div style={{ flex: 1 }}>
                    <div style={{ color: '#389e0d', fontSize: 16, fontWeight: 700 }}>Badge Authentique</div>
                    <div style={{ color: '#8c8c8c', fontSize: 12 }}>Vérifié et délivré par Nomidya E-Learning</div>
                </div>
                <LockOutlined style={{ fontSize: 16, color: '#52c41a', opacity: 0.5 }} />
            </div>

            {/* ═══ CARTE PRINCIPALE ═══ */}
            <Card style={{ borderRadius: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.08)', border: '1px solid #e8e8e8' }}
                bodyStyle={{ padding: 0 }}>

                {/* Badge visuel */}
                <div style={{ padding: '24px', textAlign: 'center', background: '#fafafa', borderRadius: '16px 16px 0 0' }}>
                    <div style={{ display: 'inline-block', position: 'relative' }}>
                        {badgeLoading ? (
                            <div style={{
                                width: bWidth, height: bHeight, background: bgColor, borderRadius: 16,
                                display: 'flex', alignItems: 'center', justifyContent: 'center',
                            }}>
                                <Spin size="large" />
                            </div>
                        ) : (
                            <div
                                ref={badgeRef}
                                style={{
                                    width: `${bWidth}px`, height: `${bHeight}px`,
                                    background: useImgBg && bgImg ? `url(${bgImg}) center/cover no-repeat` : bgColor,
                                    color: txtColor, borderRadius: 16, position: "relative",
                                    boxShadow: "0 8px 30px rgba(0,0,0,0.15)", overflow: "hidden",
                                }}
                            >
                                {logoImg && (
                                    <img src={logoImg} alt="Logo" style={{
                                        position: "absolute", top: 20, left: "50%", transform: "translateX(-50%)",
                                        width: logoW, height: logoH, borderRadius: "50%", objectFit: "cover",
                                    }} />
                                )}
                                <div style={{ padding: 20, paddingBottom: 80, height: "100%", position: "relative" }}>
                                    <div dangerouslySetInnerHTML={{ __html: processedHtml || defaultBadgeHtml }} />
                                </div>
                                <div style={{ position: "absolute", bottom: 12, right: 12, background: "rgba(255,255,255,0.15)", borderRadius: 8, padding: 6 }}>
                                    <QRCodeCanvas value={qrLink} size={52} bgColor="transparent" fgColor={txtColor} />
                                </div>
                                <div style={{ position: "absolute", bottom: 14, left: 14, fontSize: 10, opacity: 0.8, color: txtColor }}>
                                    {badgeData.generatedAt ? new Date(badgeData.generatedAt).toLocaleDateString("fr-FR") : new Date().toLocaleDateString("fr-FR")}
                                </div>
                            </div>
                        )}
                        {/* Étoile */}
                        <div style={{
                            position: 'absolute', top: -6, right: -6, background: '#faad14',
                            borderRadius: '50%', width: 28, height: 28,
                            display: 'flex', alignItems: 'center', justifyContent: 'center',
                            boxShadow: '0 3px 8px rgba(250,173,20,0.4)',
                        }}>
                            <StarFilled style={{ color: 'white', fontSize: 14 }} />
                        </div>
                    </div>
                </div>

                {/* Infos + Notes */}
                <div style={{ padding: '20px 24px 24px' }}>
                    {/* Titre */}
                    <div style={{ textAlign: 'center', marginBottom: 16 }}>
                        <TrophyOutlined style={{ fontSize: 22, color: '#faad14' }} />
                        <Title level={4} style={{ margin: '2px 0 0', fontSize: 16 }}>
                            {badgeData.title || "Badge de Réussite"}
                        </Title>
                    </div>

                    {/* Grille d'infos */}
                    <Row gutter={[10, 10]}>
                        {[
                            { icon: <UserOutlined />, label: 'Étudiant', value: badgeData.studentName, color: '#1890ff', capitalize: true },
                            { icon: <BookOutlined />, label: 'Formation', value: badgeData.courseName },
                            { icon: <CalendarOutlined />, label: 'Obtenu le', value: formattedDate },
                            { icon: <SafetyCertificateOutlined />, label: 'Code', value: badgeData.verificationCode, mono: true, color: '#667eea' },
                        ].map((item, i) => (
                            <Col span={12} key={i}>
                                <div style={{
                                    display: 'flex', alignItems: 'center', gap: 8,
                                    padding: '10px 12px', background: '#f8f9fb',
                                    borderRadius: 10, border: '1px solid #eef0f4',
                                }}>
                                    <span style={{ fontSize: 16, color: '#667eea' }}>{item.icon}</span>
                                    <div>
                                        <div style={{ fontSize: 10, color: '#aaa' }}>{item.label}</div>
                                        <div style={{
                                            fontSize: item.mono ? 11 : 13, fontWeight: 600,
                                            color: item.color || '#333',
                                            fontFamily: item.mono ? 'monospace' : 'inherit',
                                            textTransform: item.capitalize ? 'capitalize' : 'none',
                                        }}>{item.value}</div>
                                    </div>
                                </div>
                            </Col>
                        ))}
                    </Row>

                    {/* Notes */}
                    {noteFinale != null && (
                        <>
                            <Divider style={{ margin: '18px 0 14px' }}>
                                <span style={{ fontSize: 13, color: '#666' }}><BarChartOutlined /> Résultats</span>
                            </Divider>

                            <div style={{
                                background: passed ? '#f6ffed' : '#fff2f0',
                                borderRadius: 12, padding: '16px 20px', textAlign: 'center',
                                border: `1px solid ${passed ? '#b7eb8f' : '#ffccc7'}`, marginBottom: 14,
                            }}>
                                <div style={{ fontSize: 11, color: '#888' }}>Note Finale</div>
                                <div style={{ fontSize: 32, fontWeight: 800, color: passed ? '#52c41a' : '#ff4d4f' }}>
                                    {noteFinale.toFixed(2)}
                                </div>
                                <Tag color={passed ? 'success' : 'error'} style={{ fontSize: 11, padding: '1px 10px' }}>
                                    {passed ? '✅ Seuil atteint' : '❌ Non atteint'}
                                </Tag>
                                <div style={{ fontSize: 10, color: '#aaa', marginTop: 2 }}>Seuil : {threshold}</div>
                            </div>

                            <Row gutter={[8, 8]}>
                                {[
                                    { label: '📝 Contrôle', val: badgeData.noteControle, color: '#52c41a', bg: '#f6ffed', border: '#b7eb8f' },
                                    { label: '📋 Évaluation', val: badgeData.noteEvaluation, color: '#1890ff', bg: '#e6f7ff', border: '#91d5ff' },
                                    { label: '🏋️ Pratique', val: badgeData.noteTraining, color: '#fa8c16', bg: '#fff7e6', border: '#ffd591' },
                                ].filter(n => n.val != null).map((n, i) => (
                                    <Col span={8} key={i}>
                                        <div style={{
                                            textAlign: 'center', padding: '12px 6px', borderRadius: 10,
                                            background: n.bg, border: `1px solid ${n.border}`,
                                        }}>
                                            <div style={{ fontSize: 10, color: '#777' }}>{n.label}</div>
                                            <div style={{ fontSize: 20, fontWeight: 700, color: n.color }}>{n.val.toFixed(2)}</div>
                                        </div>
                                    </Col>
                                ))}
                            </Row>
                        </>
                    )}

                    {/* Bouton */}
                    <div style={{ textAlign: 'center', marginTop: 22 }}>
                        <Button type="primary" size="large" icon={<DownloadOutlined />}
                            loading={downloading} onClick={handleDownloadBadge} disabled={badgeLoading}
                            style={{
                                height: 46, paddingLeft: 28, paddingRight: 28,
                                borderRadius: 10, fontSize: 15, fontWeight: 700,
                                background: 'linear-gradient(135deg, #52c41a, #389e0d)',
                                border: 'none', boxShadow: '0 4px 14px rgba(82,196,26,0.3)',
                            }}>
                            Télécharger mon badge
                        </Button>
                    </div>
                </div>
            </Card>

            {/* Footer */}
            <div style={{
                marginTop: 16, textAlign: 'center', padding: '10px 16px',
                color: '#bbb', fontSize: 11,
            }}>
                Badge délivré par <strong>Nomidya E-Learning</strong> • Vérifiable via QR code
            </div>
        </div>
    );
};

export default BadgeVerification;